/**
 * Get the Look Carousel — Section 2
 * Mobile: native touch scroll (matches product recommendations).
 * Desktop: optional mouse drag. Tap-to-reveal sizes on touch.
 */
(function () {
  'use strict';

  var TAP_MOVE_THRESHOLD = 12;

  function isTouchUi() {
    return window.matchMedia('(hover: none)').matches;
  }

  function closeAllSizeOverlays(carouselEl) {
    carouselEl.querySelectorAll('.get-the-look-carousel__card.is-sizes-open').forEach(function (card) {
      card.classList.remove('is-sizes-open');
    });
  }

  function addToCartAndOpen(variantId, feedbackEl, pillGroup, card) {
    if (!variantId) return;

    if (feedbackEl) {
      feedbackEl.textContent = 'Adding…';
      feedbackEl.removeAttribute('hidden');
    }

    if (pillGroup) {
      pillGroup.setAttribute('aria-busy', 'true');
      pillGroup.querySelectorAll('input[type="radio"]:not([data-oos])').forEach(function (radio) {
        radio.disabled = true;
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: ['mini-cart'] }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      })
      .then(function (addResponse) {
        if (feedbackEl) {
          feedbackEl.textContent = 'Added ✓';
        }

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartData) {
            if (addResponse && addResponse.sections) {
              cartData.sections = addResponse.sections;
            }
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  cart: cartData,
                  openMiniCart: true,
                },
              })
            );
          })
          .catch(function () {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { openMiniCart: true },
              })
            );
          });

        setTimeout(function () {
          if (feedbackEl) feedbackEl.setAttribute('hidden', '');
          if (pillGroup) {
            pillGroup.removeAttribute('aria-busy');
            pillGroup.querySelectorAll('input[type="radio"]:not([data-oos])').forEach(function (radio) {
              radio.disabled = false;
              radio.checked = false;
            });
          }
          if (card) {
            card.classList.remove('is-sizes-open');
          }
        }, 1800);
      })
      .catch(function (err) {
        console.error('Get the Look Carousel — add to cart failed:', err);
        var msg = (err && err.description) ? err.description : 'Error — please try again';
        if (feedbackEl) {
          feedbackEl.textContent = msg;
          setTimeout(function () { feedbackEl.setAttribute('hidden', ''); }, 2500);
        }
        if (pillGroup) {
          pillGroup.removeAttribute('aria-busy');
          pillGroup.querySelectorAll('input[type="radio"]:not([data-oos])').forEach(function (radio) {
            radio.disabled = false;
          });
        }
      });
  }

  function initMobileSizeToggle(carouselEl) {
    if (!isTouchUi()) return;

    carouselEl.querySelectorAll('[data-carousel-media]').forEach(function (media) {
      var card = media.closest('.get-the-look-carousel__card');
      var overlay = media.querySelector('.get-the-look-carousel__sizes-overlay');
      var startX = 0;
      var startY = 0;
      var moved = false;

      media.addEventListener(
        'touchstart',
        function (event) {
          if (event.target.closest('[data-carousel-size-pills]')) return;
          var touch = event.changedTouches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          moved = false;
        },
        { passive: true }
      );

      media.addEventListener(
        'touchmove',
        function (event) {
          if (event.target.closest('[data-carousel-size-pills]')) return;
          var touch = event.changedTouches[0];
          if (
            Math.abs(touch.clientX - startX) > TAP_MOVE_THRESHOLD ||
            Math.abs(touch.clientY - startY) > TAP_MOVE_THRESHOLD
          ) {
            moved = true;
          }
        },
        { passive: true }
      );

      media.addEventListener('touchend', function (event) {
        if (event.target.closest('[data-carousel-size-pills]')) return;
        if (moved) return;

        var isOpen = card.classList.contains('is-sizes-open');
        closeAllSizeOverlays(carouselEl);

        if (!isOpen) {
          card.classList.add('is-sizes-open');
        }
      });

      if (overlay) {
        overlay.addEventListener('touchend', function (event) {
          if (event.target.closest('[data-carousel-size-pills]')) return;
          card.classList.remove('is-sizes-open');
        });
      }
    });

    document.addEventListener('touchend', function (event) {
      if (!carouselEl.contains(event.target)) {
        closeAllSizeOverlays(carouselEl);
        return;
      }

      if (event.target.closest('[data-carousel-size-pills]')) return;
      if (event.target.closest('[data-carousel-media]')) return;

      closeAllSizeOverlays(carouselEl);
    });
  }

  function initDesktopTrackDrag(carouselEl, track) {
    if (isTouchUi()) return;

    var pendingDrag = false;
    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var momentumId = null;
    var activePointerId = null;

    function stopMomentum() {
      if (momentumId) {
        cancelAnimationFrame(momentumId);
        momentumId = null;
      }
    }

    function runMomentum() {
      if (Math.abs(velocity) < 0.05) {
        momentumId = null;
        return;
      }
      track.scrollLeft -= velocity;
      velocity *= 0.92;
      momentumId = requestAnimationFrame(runMomentum);
    }

    function isSizePillTarget(target) {
      return target.closest('[data-carousel-size-pills] label, [data-carousel-size-pills] input');
    }

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse') return;
      if (isSizePillTarget(event.target)) return;
      if (event.button !== 0) return;

      pendingDrag = true;
      isDragging = false;
      activePointerId = event.pointerId;
      stopMomentum();

      startX = event.clientX;
      scrollStart = track.scrollLeft;
      lastX = event.clientX;
      lastTime = performance.now();
      velocity = 0;
    });

    track.addEventListener('pointermove', function (event) {
      if (event.pointerType !== 'mouse') return;
      if (!pendingDrag && !isDragging) return;
      if (event.pointerId !== activePointerId) return;

      var deltaFromStart = event.clientX - startX;

      if (!isDragging && pendingDrag && Math.abs(deltaFromStart) > TAP_MOVE_THRESHOLD) {
        isDragging = true;
        pendingDrag = false;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
        closeAllSizeOverlays(carouselEl);
      }

      if (!isDragging) return;

      track.scrollLeft = scrollStart - deltaFromStart;

      var now = performance.now();
      var dt = now - lastTime;
      if (dt > 0) {
        velocity = ((event.clientX - lastX) / dt) * 16;
      }
      lastX = event.clientX;
      lastTime = now;
    });

    function endDrag(event) {
      if (event.pointerType !== 'mouse') return;
      if (event.pointerId !== activePointerId) return;

      pendingDrag = false;

      if (isDragging) {
        isDragging = false;
        track.classList.remove('is-dragging');

        if (track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }

        velocity *= 1.6;
        runMomentum();
      }

      activePointerId = null;
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
  }

  function initCarousel(carouselEl) {
    var track = carouselEl.querySelector('[data-carousel-track]');
    if (track) {
      initDesktopTrackDrag(carouselEl, track);
    }

    initMobileSizeToggle(carouselEl);

    carouselEl.querySelectorAll('[data-carousel-size-pills]').forEach(function (pillGroup) {
      pillGroup.addEventListener('change', function (evt) {
        var radio = evt.target;
        if (radio.type !== 'radio' || radio.disabled || radio.hasAttribute('data-oos')) return;

        var variantId = radio.value || radio.getAttribute('data-variant-id');
        if (!variantId) return;

        var card = radio.closest('[data-carousel-product-id]');
        var feedbackEl = card ? card.querySelector('.get-the-look-carousel__feedback') : null;

        addToCartAndOpen(variantId, feedbackEl, pillGroup, card);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-get-the-look-carousel]').forEach(initCarousel);
  });
})();
